import React, { useEffect, useState } from "react";
import { fetchEvacZoneHistory } from "../lib/api";
import { EVAC_LEVEL_META, EVAC_STATUS_META } from "./map/SheriffEvacLayer";

const fmtDT = (iso) =>
  iso
    ? new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })
    : "—";

const statusWord = (s) => (EVAC_STATUS_META[s] || {}).label || null;

function eventLine(e) {
  if (e.event === "posted")
    return `Posted — Level ${e.level ?? "?"}${statusWord(e.status) ? ` · ${statusWord(e.status)}` : ""}`;
  if (e.event === "lifted") return "Lifted — zone rescinded";
  if (e.event === "reactivated") return `Reactivated — Level ${e.level ?? "?"}`;
  const bits = [];
  if (e.prev_level !== e.level) bits.push(`Level ${e.prev_level ?? "?"} → Level ${e.level ?? "?"}`);
  if (e.status && e.prev_status && e.status !== e.prev_status) bits.push(statusWord(e.status));
  return bits.join(" · ") || "Updated";
}

export default function EvacZoneTimeline({ zoneId }) {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchEvacZoneHistory(zoneId)
      .then((d) => alive && setEvents(d.events || []))
      .catch(() => alive && setEvents([]));
    return () => { alive = false; };
  }, [zoneId]);

  if (events === null)
    return <div className="text-[12px] text-tac-faint pl-2 py-1" data-testid={`evac-timeline-loading-${zoneId}`}>Loading timeline…</div>;
  if (!events.length)
    return <div className="text-[12px] text-tac-faint pl-2 py-1" data-testid={`evac-timeline-empty-${zoneId}`}>No recorded changes for this zone yet.</div>;

  return (
    <ol className="mt-1.5 border-l-2 border-tac-border/60 pl-3 space-y-1.5" data-testid={`evac-timeline-${zoneId}`}>
      {events.map((e, i) => {
        const color = e.event === "lifted" ? "#6B7280" : (EVAC_LEVEL_META[e.level] || {}).color || "#979F91";
        return (
          <li key={`${e.at}-${i}`} className="flex items-start gap-2 text-[12px]" data-testid={`evac-timeline-event-${zoneId}-${i}`}>
            <span className="mt-1 w-2 h-2 rounded-full shrink-0 -ml-[19px] border-2 border-tac-surface" style={{ background: color }} />
            <span className="text-tac-text leading-snug">{eventLine(e)}</span>
            <span className="font-mono-tac text-tac-faint ml-auto whitespace-nowrap">{fmtDT(e.at)}</span>
          </li>
        );
      })}
    </ol>
  );
}
